import './page-sub-header.scss';

import React from 'react';
import classnames from 'classnames';

export const PageSubHeader: React.FunctionComponent<{ className?: string }> = ({ children, className }) => (
  <div className={classnames('pageSubHeader', className)}>{children}</div>
);
